import React from 'react';

import { Spacing } from '../../styles/CommonStyles';
import { LandingContents2 } from '../../styles/LandingStyles';
import InnerContainer from './InnerContainer';
import Typography from '../common/typography/Typography';
import ComparisonSlider from '../media/ComparisonSlider';

import useLanguagePack from '../../hooks/useLanguagePack';

const Section4 = () => {
  const languageKeyStrings = {
    title: useLanguagePack('landing_contents2_title_1'),
    contents: useLanguagePack('landing_contents2_text_1'),

    title1: useLanguagePack('renew_landing_24'),
    title2: useLanguagePack('renew_landing_25'),
    title3: useLanguagePack('renew_landing_26'),
    title4: useLanguagePack('renew_landing_27'),
    title5: useLanguagePack('renew_landing_28'),

    contents1: useLanguagePack('renew_landing_41'),
    contents2: useLanguagePack('renew_landing_37'),
    contents3: useLanguagePack('renew_landing_38'),
    contents4: useLanguagePack('renew_landing_39'),
    contents5: useLanguagePack('renew_landing_40'),
  };
  return (
    <LandingContents2>
      <div style={{ width: '1200px', margin: '0 auto', display: 'flex', gap: '64px', marginBottom: '5rem' }}>
        <img src='/assets/image/newLanding/landing_sec3_1.png' alt='KEYCUTstock x Artist' />
        <div style={{ textAlign: 'start',width:'100%',display:'flex',justifyContent:'left' }}>
          <div>
          <Typography variant={'T1'}>{languageKeyStrings.title1}</Typography>
          <Typography variant={'C3'} color={'gray'}>
            {languageKeyStrings.contents1}
          </Typography>
          </div>
        </div>
      </div>
      <div style={{ width: '1200px', margin: '0 auto', display: 'flex', gap: '64px', marginBottom: '5rem'}}>
      <div style={{ textAlign: 'start',width:'100%',display:'flex',justifyContent:'left',marginLeft:'64px' }}>
        <div>
          <Typography variant={'T1'}>{languageKeyStrings.title2}</Typography>
          <Typography variant={'C3'} color={'gray'}>
            {languageKeyStrings.contents2}
          </Typography>
          </div>
        </div>
        <img src='/assets/image/newLanding/landing_sec3_2.png' alt='KEYCUTstock x Artist' />
      </div>
      <div style={{ width: '1200px', margin: '0 auto', display: 'flex', gap: '64px', marginBottom: '5rem'}}>
        <img src='/assets/image/newLanding/landing_sec3_3.png' alt='KEYCUTstock x Artist' />
        <div style={{ textAlign: 'start',width:'100%',display:'flex',justifyContent:'left' }}>
        <div>
          <Typography variant={'T1'}>{languageKeyStrings.title3}</Typography>
          <Typography variant={'C3'} color={'gray'}>
            {languageKeyStrings.contents3}
          </Typography>
          </div>
        </div>
      </div>
      <div style={{ width: '1200px', margin: '0 auto', display: 'flex', gap: '64px', marginBottom: '5rem' }}>
      <div style={{ textAlign: 'start',width:'100%',display:'flex',justifyContent:'left',marginLeft:'64px'}}>
        <div>
          <Typography variant={'T1'}>{languageKeyStrings.title4}</Typography>
          <Typography variant={'C3'} color={'gray'}>
            {languageKeyStrings.contents4}
          </Typography>
          </div>
        </div>
        <img src='/assets/image/newLanding/landing_sec3_4.png' alt='KEYCUTstock x Artist' />
      </div>
      <div style={{ width: '1200px', margin: '0 auto', display: 'flex', gap: '64px', marginBottom: '5rem',justifyContent:'space-between' }}>
        <ComparisonSlider />
        <div style={{ textAlign: 'start',width:'100%',display:'flex',justifyContent:'left' }}>
        <div>
          <Typography variant={'T1'}>{languageKeyStrings.title5}</Typography>
          <Typography variant={'C3'} color={'gray'}>
            {languageKeyStrings.contents5}
          </Typography>
          </div>
        </div>
      </div>
    </LandingContents2>
  );
};

export default Section4;
